import { Region } from './region-enum';

enum CampaignStep {
    Properties = 0,
    Coupon = 1,
    RulesAndEarnings = 2,
    WebsiteAppearance = 3,
    Priority = 4,
    Stackables = 5,
    Summary = 6,
}

enum CampaignSortModel {
    Ascending = 0,
    Descending = 1,
}

enum CampaignFileTypes {
    Customer = 1,
    Coupon = 2,
    CouponCustomer = 3,
    Option = 4,
    Store = 5,
}

enum CampaignStatus {
    Passive = 0,
    Active = 1,
    Paused = 2,
    Template = 3,
    Test = 4,
}

enum CampaignRepeatType {
    None = 0,
    Daily = 1,
    Weekly = 2,
}

enum CampaignRepeatDay {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

enum RuleAndEarningModalNames {
    Earning = 'Earning',
    Rule = 'Rule',
    RuleCondition = 'RuleCondition',
    RuleBulkCreate = 'RuleBulkCreate',
}

enum RuleFormInput {
    Id = 'id',
    CampaignRuleId = 'campaignRuleId',
    RuleType = 'ruleType',
    RuleName = 'ruleName',
    Condition = 'condition',
    ValueSelect = 'valueSelect',
    ValueNumber = 'valueNumber',
    ValueSwitch = 'valueSwitch',
    ValueFile = 'valueFile',
}

enum RuleExecutionType {
    Queue = 1,
    Completed = 2,
    Error = 3,
}

enum RuleType {
    CustomerType = 1,
    // LocationType= 2,
    // Region= 3,
    Platform = 4,
    DeliveryMethod = 5,
    UsageLimit = 6,
    CustomerInformation = 7,
    ShippingCompany = 8,
    OrderAmount = 9,
    PaymentMethod = 10,
    Quantity = 11,
    AtFirstOrder = 12,
    OnlyNewCustomers = 13,
    CreditCardType = 14,
    // IsNewCreditCard= 15,
    // IsDebitCreditCard= 16,
    NewsCustomerMustJoinedAfterStartDate = 17,
    Option = 18,
    Store = 19,
    PaymentCollector = 21,
    CouponMethod = 22,
}

enum RuleCondition {
    Includes = 1,
    Excludes = 2,
    GreaterThan = 3,
    LessThan = 4,
    EqualsThan = 5,
}

enum RuleCustomerType {
    Employee = 1,
    Registered = 2,
    Visitor = 5,
    Guest = 6,
}

enum RulePlatform {
    Android = 1,
    IOS = 2,
    WindowsPhone = 3,
    Web = 4,
    Windows = 5,
    WebApi = 6,
}

enum RuleDeliveryMethod {
    ShipToCustomerAddress = 1,
    StorePickup = 2,
    // StorePickupClickCollect = 4,
    // FastDelivery = 5,
    NovaPoshtaPickPoint = 30,
    X5PickPoint = 30,
    SamedayLockerPickPoint = 30,
    PickPoint = 30,
    ParcelShopPickPoint = 30,
    EcontPickPoint = 30,
}

enum RuleShippingCompany {
    // SpsrAse = 3,
    // Grooger = 8,
    NovaPoshta = 22,
    Pony = 24,
    UpsFrance = 45,
    // UpsGermany = 51,
    UpsItaly = 52,
    DpdRomania = 46,
    DpdBulgaria = 53,
    TntCargo = 55,
    RussianPost = 59,
    CityExpressCargo = 60,
    X5PickPoint = 62,
    Aramex = 63,
    Sameday = 65,
    Econt = 68,
    Shopini = 70,
    OnwayCargo = 77,
    ChronoDialiCargo = 79,
    LcwDelivery = 80,
    ZMC = 81,
    PacketaCargoFrance = 82,
    PacketaCargoItaly = 83,
    PacketaCargoGreece = 84,
    DhlGeShipping = 7006,
}

enum RulePaymentMethod {
    // BankTransfer = 1,
    CreditCard = 2,
    LcwMoney = 3,
    // GiftCard = 5,
    // EWallet = 6,
    CashOnDoor = 7,
    CreditCardSerbiaBosnia = 26,
    CashOnDoorBalkans = 61,
    CreditCardBalkans = 125,
    // MarketPlace = 8,
    // RaschetPay = 21,
    // Adyen = 22,
}

enum RuleCreditCardType {
    Visa = 'Visa',
    MasterCard = 'MasterCard',
    Maestro = 'Maestro',
}

enum RuleSwitchValue {
    True = 'true',
    False = 'false',
}

enum RulePaymentCollector {
    Kaspi = 115,
    Halykbank = 103,
}

enum EarningFormInput {
    Id = 'id',
    CampaignRuleId = 'campaignRuleId',
    CampaignFilterRuleId = 'campaignFilterRuleId',
    Name = 'name',
    CalculationDiscountType = 'calculationDiscountType',
    OptionalSetting = 'optionalSetting',
    Value = 'value',
    PriceSortingType = 'priceSortingType',
    MaxDiscountAmount = 'maxDiscountAmount',
    MaxDiscountedProductCount = 'maxDiscountedProductCount',
    NumberOfFreeItems = 'numberOfFreeItems',
    NumberOfItemPurchasedNthProduct = 'numberOfItemPurchasedNthProduct',
    NumberOfItemPurchased = 'numberOfItemPurchased',
    OnlyNonDiscountedProducts = 'onlyNonDiscountedProducts',
    ApplicationScopeType = 'applicationScopeType',
    ProductDiscountScopeType = 'productDiscountScopeType',
    DistributionType = 'distributionType',
    UseDiscountedPrice = 'useDiscountedPrice',
    IncludeShippingPriceToGrandTotal = 'includeShippingPriceToGrandTotal',
    ShowDiscountedPrice = 'showDiscountedPrice',
}

enum EarningApplicationScopeType {
    Shipping = 0,
    Order = 1,
    Product = 2,
}

enum EarningProductDiscountScopeType {
    None = 0,
    ApplyToProduct = 1,
    ApplyToNthProducts = 2,
    BuyNPayY = 3,
}

enum EarningCalculationDiscountType {
    Percentage = 0,
    FixedPrice = 1,
    StaticDiscount = 2,
    Promotion = 3,
}

enum EarningOptionalSetting {
    MaxDiscountAmount = 0,
    IncludeShippingPriceToGrandTotal = 1,
    UseDiscountedPrice = 2,
    OnlyNonDiscountedProducts = 3,
    PriceSortingType = 4,
    MaxDiscountedProductCount = 5,
    DistributionType = 6,
    ShowDiscountedPrice = 7,
}

enum EarningValue {
    False = 0,
    True = 1,
}

enum EarningBasePrice {
    CampaignPrice = 0,
    PriceWithoutCampaign = 1,
}

enum EarningPriceSortingType {
    LowToHighPrice = 0,
    HighToLowPrice = 1,
}

enum EarningDistributionType {
    Quantity = 0,
    QuantityAndPrice = 1,
}

enum CouponFormInput {
    Id = 'id',
    CampaignRuleId = 'campaignRuleId',
    CouponName = 'couponName',
    CouponCode = 'couponCode',
    CharacterSet = 'characterSet',
    Prefix = 'prefix',
    Postfix = 'postFix',
    UserFileId = 'userFileId',
    PerCustomerCouponCount = 'perCustomerCouponCount',
    TotalCouponCount = 'totalCouponCount',
    Status = 'status',
}

enum CouponStatus {
    Passive = 0,
    Active = 1,
}

enum CouponGenerationType {
    Generic = 1,
    Unique = 2,
    Personal = 3,
    Excel = 4,
}

enum CouponExecutionType {
    Queue = 1,
    Completed = 2,
    Error = 3,
}

enum CouponCharacterSetType {
    Latin = 1,
    Kiril = 2,
    Arabic = 3,
    Georgian = 4,
}

enum WebsiteFolderType {
    UserFolder = 1,
    JunkFolder = 2,
}

enum MatrixCampaignType {
    DontMerge = 0,
    Merged = 1,
    DontApplySameProducts = 2,
}

enum LogTimeRange {
    Last5Minute = 1,
    Last10Minute = 2,
    Last30Minute = 3,
    CustomRange = 4,
}

const CampaignSteps = [
    { id: CampaignStep.Properties, name: 'campaignManagement.save.step.properties.title' },
    { id: CampaignStep.Coupon, name: 'campaignManagement.save.step.coupon.title' },
    { id: CampaignStep.RulesAndEarnings, name: 'campaignManagement.save.step.rulesAndEarnings.title' },
    { id: CampaignStep.WebsiteAppearance, name: 'campaignManagement.save.step.websiteAppearance.title' },
    { id: CampaignStep.Priority, name: 'campaignManagement.save.step.priority.title' },
    { id: CampaignStep.Stackables, name: 'campaignManagement.save.step.stackable.title' },
    { id: CampaignStep.Summary, name: 'campaignManagement.save.step.summary.title' },
];

const CampaignStatuses = [
    { id: CampaignStatus.Passive, name: 'campaignManagement.search.campaignStatus.passive', color: '#bdbdbd' },
    { id: CampaignStatus.Active, name: 'campaignManagement.search.campaignStatus.active', color: '#2ad24e' },
    { id: CampaignStatus.Paused, name: 'campaignManagement.search.campaignStatus.paused', color: '#ffa500' },
    { id: CampaignStatus.Template, name: 'campaignManagement.search.campaignStatus.template', color: '#2262bf' },
    { id: CampaignStatus.Test, name: 'campaignManagement.search.campaignStatus.test', color: '#a722bf' },
];

const CampaignRepeatTypes = [
    { id: CampaignRepeatType.None, name: 'campaignManagement.save.step.properties.reiterationOption.none' },
    { id: CampaignRepeatType.Daily, name: 'campaignManagement.save.step.properties.reiterationOption.daily' },
    { id: CampaignRepeatType.Weekly, name: 'campaignManagement.save.step.properties.reiterationOption.weekly' },
];

const CampaignRepeatDays = [
    { id: CampaignRepeatDay.Sunday, name: 'campaignManagement.save.step.properties.recurrenceOption.sunday' },
    { id: CampaignRepeatDay.Monday, name: 'campaignManagement.save.step.properties.recurrenceOption.monday' },
    { id: CampaignRepeatDay.Tuesday, name: 'campaignManagement.save.step.properties.recurrenceOption.tuesday' },
    { id: CampaignRepeatDay.Wednesday, name: 'campaignManagement.save.step.properties.recurrenceOption.wednesday' },
    { id: CampaignRepeatDay.Thursday, name: 'campaignManagement.save.step.properties.recurrenceOption.thursday' },
    { id: CampaignRepeatDay.Friday, name: 'campaignManagement.save.step.properties.recurrenceOption.friday' },
    { id: CampaignRepeatDay.Saturday, name: 'campaignManagement.save.step.properties.recurrenceOption.saturday' },
];

const RuleListCondition = [
    {
        id: RuleCondition.Includes,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.conditionOption.include',
    },
    {
        id: RuleCondition.Excludes,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.conditionOption.exclude',
    },
];

const RuleNumberCondition = [
    {
        id: RuleCondition.GreaterThan,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.conditionOption.greaterEqualThan',
    },
    {
        id: RuleCondition.LessThan,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.conditionOption.lessEqualThan',
    },
    {
        id: RuleCondition.EqualsThan,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.conditionOption.equals',
    },
];

const RuleBooleanCondition = [
    {
        id: RuleCondition.EqualsThan,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.conditionOption.equals',
    },
];

const RuleCustomerTypeValues = [
    {
        id: RuleCustomerType.Employee,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.valueOption.employee',
        regions: [
            Region.Russia,
            Region.Kazakhistan,
            Region.Ukraine,
            Region.Iraq,
            Region.Georgia,
            Region.Egypt,
            Region.Serbia,
            Region.Morrocco,
            Region.Romania,
            Region.Bulgaria,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Germany,
            Region.Croatia,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
        ],
    },
    {
        id: RuleCustomerType.Registered,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.valueOption.customer',
        regions: [
            Region.Russia,
            Region.Kazakhistan,
            Region.Ukraine,
            Region.Iraq,
            Region.Georgia,
            Region.Egypt,
            Region.Serbia,
            Region.Morrocco,
            Region.Romania,
            Region.Bulgaria,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Germany,
            Region.Croatia,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
        ],
    },
    // { id: RuleCustomerType.Visitor, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.valueOption.visitor", regions : [25] },
    {
        id: RuleCustomerType.Guest,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.valueOption.guest',
        regions: [
            Region.Russia,
            Region.Kazakhistan,
            Region.Georgia,
            Region.Egypt,
            Region.Serbia,
            Region.Morrocco,
            Region.Romania,
            Region.Bulgaria,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Germany,
            Region.Ukraine,
            Region.Iraq,
            Region.Croatia,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
        ],
    },
    {
        id: RuleCustomerType.Visitor,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.valueOption.visitor',
        regions: [
            Region.Russia,
            Region.Kazakhistan,
            Region.Georgia,
            Region.Egypt,
            Region.Serbia,
            Region.Morrocco,
            Region.Romania,
            Region.Bulgaria,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Germany,
            Region.Ukraine,
            Region.Iraq,
            Region.Croatia,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
        ],
    },
];

const RulePlatformValues = [
    {
        id: RulePlatform.Android,
        name: 'Android',
        regions: [
            Region.Egypt,
            Region.Russia,
            Region.Romania,
            Region.Serbia,
            Region.Kazakhistan,
            Region.Bulgaria,
            Region.Iraq,
            Region.Croatia,
            Region.Ukraine,
            Region.Greece,
            Region.Morrocco,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
            Region.Georgia,
        ],
    },
    {
        id: RulePlatform.IOS,
        name: 'iOS',
        regions: [
            Region.Egypt,
            Region.Russia,
            Region.Romania,
            Region.Serbia,
            Region.Kazakhistan,
            Region.Bulgaria,
            Region.Iraq,
            Region.Croatia,
            Region.Ukraine,
            Region.Greece,
            Region.Morrocco,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
            Region.Georgia,
        ],
    },
    // { id: RulePlatform.WindowsPhone, name: "Windows Phone", , regions : [25] },
    {
        id: RulePlatform.Web,
        name: 'Web',
        regions: [
            Region.Egypt,
            Region.Russia,
            Region.Kazakhistan,
            Region.Georgia,
            Region.Iraq,
            Region.Morrocco,
            Region.Ukraine,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Romania,
            Region.Bulgaria,
            Region.Serbia,
            Region.Croatia,
            Region.Ukraine,
            Region.Greece,
            Region.Morrocco,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
            Region.Georgia,
        ],
    },
    // { id: RulePlatform.Windows, name: "Windows", regions : [25] },
    // { id: RulePlatform.WebApi, name: "Web Api", regions : [25] },
];

const RuleDeliveryMethodValues = [
    {
        id: RuleDeliveryMethod.ShipToCustomerAddress,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.shipToCustomerAddress',
        regions: [
            Region.Egypt,
            Region.Russia,
            Region.Kazakhistan,
            Region.Georgia,
            Region.Iraq,
            Region.Morrocco,
            Region.Ukraine,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Romania,
            Region.Bulgaria,
            Region.Serbia,
            Region.Croatia,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
        ],
    },
    {
        id: RuleDeliveryMethod.StorePickup,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.storePickup',
        regions: [
            Region.Kazakhistan,
            Region.Morrocco,
            Region.Serbia,
            Region.Romania,
            Region.Iraq,
            Region.Egypt,
            Region.Macedonia,
            Region.Kosovo,
            Region.Montenegro,
            Region.Albania,
            Region.Bosnia,
        ],
    },
    // { id: RuleDeliveryMethod.StorePickupClickCollect, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.storePickupClickCollect", regions : [25] },
    // { id: RuleDeliveryMethod.FastDelivery, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.fastDelivery", regions : [25] },
    {
        id: RuleDeliveryMethod.NovaPoshtaPickPoint,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.novaPoshtaPickPoint',
        regions: [Region.Kazakhistan, Region.Ukraine],
    },
    {
        id: RuleDeliveryMethod.X5PickPoint,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.x5PickPoint',
        regions: [Region.Russia],
    },
    {
        id: RuleDeliveryMethod.SamedayLockerPickPoint,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.sameDayLockerPickPoint',
        regions: [Region.Romania],
    },
    // {
    //     id: RuleDeliveryMethod.ParcelShopPickPoint,
    //     name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.parcelShopPickPoint',
    //     regions: [Region.Serbia],
    // },
    {
        id: RuleDeliveryMethod.EcontPickPoint,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.econtPickPoint',
        regions: [Region.Bulgaria],
    },
    {
        id: RuleDeliveryMethod.PickPoint,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.deliveryMethodValueOption.pickPoint',
        regions: [Region.Serbia],
    },
];

const RuleShippingCompanyValues = [
    // { id: RuleShippingCompany.SpsrAse, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.spsrAse", regions : [25] },
    // { id: RuleShippingCompany.Grooger, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.grooger", regions : [25] },
    {
        id: RuleShippingCompany.NovaPoshta,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.novaPoshta',
        regions: [Region.Kazakhistan, Region.Ukraine],
    },
    {
        id: RuleShippingCompany.Pony,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.pony',
        regions: [Region.Kazakhistan],
    },
    {
        id: RuleShippingCompany.UpsFrance,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.upsFrance',
        regions: [Region.France],
    },
    // { id: RuleShippingCompany.UpsGermany, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.upsGermany", regions : [25] },
    {
        id: RuleShippingCompany.UpsItaly,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.upsItaly',
        regions: [Region.Italy],
    },
    {
        id: RuleShippingCompany.DpdRomania,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.dpdRomania',
        regions: [Region.Romania],
    },
    {
        id: RuleShippingCompany.DpdBulgaria,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.dpdBulgaria',
        regions: [Region.Bulgaria],
    },
    {
        id: RuleShippingCompany.Sameday,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.sameday',
        regions: [Region.Romania],
    },
    {
        id: RuleShippingCompany.Econt,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.econt',
        regions: [Region.Bulgaria],
    },
    {
        id: RuleShippingCompany.TntCargo,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.tntCargo',
        regions: [Region.Georgia],
    },
    {
        id: RuleShippingCompany.RussianPost,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.russianPost',
        regions: [Region.Russia],
    },
    {
        id: RuleShippingCompany.CityExpressCargo,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.cityExpressCargo',
        regions: [Region.Serbia],
    },
    {
        id: RuleShippingCompany.X5PickPoint,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.x5PickPoint',
        regions: [Region.Russia],
    },
    {
        id: RuleShippingCompany.Aramex,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.aramex',
        regions: [Region.Egypt],
    },
    {
        id: RuleShippingCompany.Shopini,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.shopini',
        regions: [Region.Iraq],
    },
    {
        id: RuleShippingCompany.OnwayCargo,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.onwayCargo',
        regions: [Region.Georgia],
    },
    {
        id: RuleShippingCompany.ChronoDialiCargo,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.chronoDialiCargo',
        regions: [Region.Morrocco],
    },
    {
        id: RuleShippingCompany.LcwDelivery,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.lcwDelivery',
        regions: [Region.Kazakhistan],
    },
    {
        id: RuleShippingCompany.ZMC,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.zmc',
        regions: [Region.Iraq],
    },
    {
        id: RuleShippingCompany.PacketaCargoFrance,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.packetaCargo',
        regions: [Region.France],
    },
    {
        id: RuleShippingCompany.PacketaCargoItaly,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.packetaCargo',
        regions: [Region.Italy],
    },
    {
        id: RuleShippingCompany.PacketaCargoGreece,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.packetaCargo',
        regions: [Region.Greece],
    },
    {
        id: RuleShippingCompany.DhlGeShipping,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.shippingCompanyValueOption.dhlGeShipping',
        regions: [Region.Georgia],
    },
];

const RulePaymentMethodValues = [
    // { id: RulePaymentMethod.BankTransfer, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.bankTransfer", regions : [25] },
    {
        id: RulePaymentMethod.CreditCard,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.creditCard',
        regions: [
            Region.Egypt,
            Region.Kazakhistan,
            Region.Georgia,
            Region.Morrocco,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Romania,
            Region.Bulgaria,
            Region.Iraq,
            Region.Ukraine,
            Region.Croatia,
            Region.Russia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
            Region.Serbia,
            Region.Bosnia,
        ],
    },
    {
        id: RulePaymentMethod.LcwMoney,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.lcwMoney',
        regions: [
            Region.Egypt,
            Region.Kazakhistan,
            Region.Morrocco,
            Region.Greece,
            Region.Romania,
            Region.Bulgaria,
            Region.Iraq,
        ],
    },
    // { id: RulePaymentMethod.GiftCard, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.giftCard", regions : [25] },
    // { id: RulePaymentMethod.EWallet, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.eWallet", regions : [25] },
    {
        id: RulePaymentMethod.CashOnDoor,
        name: 'campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.cashOnDoor',
        regions: [
            Region.Egypt,
            Region.Kazakhistan,
            Region.Georgia,
            Region.Ukraine,
            Region.Morrocco,
            Region.Greece,
            Region.Romania,
            Region.Bulgaria,
            Region.Iraq,
            Region.Croatia,
            Region.Russia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Serbia,
            Region.Bosnia,
            Region.Macedonia,
        ],
    },
    // { id: RulePaymentMethod.MarketPlace, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.marketPlace", regions : [25] },
    // { id: RulePaymentMethod.RaschetPay, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.raschetPay", regions : [25] },
    // { id: RulePaymentMethod.Adyen, name: "campaignManagement.save.step.rulesAndEarnings.rule.form.paymentMethodValueOption.adyen", regions : [25] },
];

const RulePaymentCollectorValues = [
    {
        id: RulePaymentCollector.Kaspi,
        name: 'Kaspi',
        regions: [Region.Kazakhistan],
    },
    {
        id: RulePaymentCollector.Halykbank,
        name: 'Halykbank',
        regions: [Region.Kazakhistan],
    },
];

const RuleCreditCardTypeValues = [
    { id: RuleCreditCardType.Visa, name: 'Visa', regions: [Region.Kazakhistan, Region.Ukraine] },
    { id: RuleCreditCardType.MasterCard, name: 'MasterCard', regions: [Region.Kazakhistan, Region.Ukraine] },
    { id: RuleCreditCardType.Maestro, name: 'Maestro', regions: [Region.Kazakhistan, Region.Ukraine] },
];

const EarningApplicationScopeTypeValues = [
    { id: EarningApplicationScopeType.Order, name: 'campaignManagement.search.campaignTypeOptions.order' },
    { id: EarningApplicationScopeType.Product, name: 'campaignManagement.search.campaignTypeOptions.product' },
    { id: EarningApplicationScopeType.Shipping, name: 'campaignManagement.search.campaignTypeOptions.shipping' },
];

const MatrixCampaignTypes = {
    DontMerge: {
        id: MatrixCampaignType.DontMerge,
        title: 'campaignManagement.save.step.stackable.dontMerge.title',
        shortKey: 'campaignManagement.save.step.stackable.shortKey.standalone',
        description: 'campaignManagement.save.step.stackable.dontMerge.description',
    },
    Merged: {
        id: MatrixCampaignType.Merged,
        title: 'campaignManagement.save.step.stackable.merged.title',
        shortKey: 'campaignManagement.save.step.stackable.shortKey.merged',
        description: 'campaignManagement.save.step.stackable.merged.description',
    },
    DontApplySameProducts: {
        id: MatrixCampaignType.DontApplySameProducts,
        title: 'campaignManagement.save.step.stackable.dontApplyToSameProducts.title',
        shortKey: 'campaignManagement.save.step.stackable.shortKey.dontApplyToSameProducts',
        description: 'campaignManagement.save.step.stackable.dontApplyToSameProducts.description',
    },
};

const CouponGenerationTypes = [
    { id: CouponGenerationType.Generic, name: 'campaignManagement.save.step.coupon.form.couponTypeOption.generic' },
    { id: CouponGenerationType.Unique, name: 'campaignManagement.save.step.coupon.form.couponTypeOption.unique' },
    { id: CouponGenerationType.Personal, name: 'campaignManagement.save.step.coupon.form.couponTypeOption.personal' },
    { id: CouponGenerationType.Excel, name: 'campaignManagement.save.step.coupon.form.couponTypeOption.excel' },
];

const CouponCharacterSetTypes = [
    {
        id: CouponCharacterSetType.Latin,
        name: 'campaignManagement.save.step.coupon.form.characterSetOption.latin',
        regions: [
            Region.Egypt,
            Region.Russia,
            Region.Kazakhistan,
            Region.Georgia,
            Region.Iraq,
            Region.Morrocco,
            Region.Ukraine,
            Region.France,
            Region.Greece,
            Region.Italy,
            Region.Romania,
            Region.Bulgaria,
            Region.Serbia,
            Region.Germany,
            Region.Croatia,
            Region.Bosnia,
            Region.Albania,
            Region.Montenegro,
            Region.Kosovo,
            Region.Macedonia,
            Region.Turkey,
        ],
    },
    {
        id: CouponCharacterSetType.Kiril,
        name: 'campaignManagement.save.step.coupon.form.characterSetOption.kiril',
        regions: [
            Region.Russia,
            Region.Macedonia,
            Region.Montenegro,
            Region.Ukraine,
            Region.Bulgaria,
            Region.Serbia,
            Region.Bosnia,
        ],
    },
    {
        id: CouponCharacterSetType.Arabic,
        name: 'campaignManagement.save.step.coupon.form.characterSetOption.arabic',
        regions: [Region.Egypt, Region.Iraq, Region.Morrocco],
    },
    {
        id: CouponCharacterSetType.Georgian,
        name: 'campaignManagement.save.step.coupon.form.characterSetOption.georgian',
        regions: [Region.Georgia],
    },
];

const LogTimeRanges = [
    { id: LogTimeRange.Last5Minute, name: 'campaignManagement.logs.list.filter.timeRange.options.last5Minute' },
    { id: LogTimeRange.Last10Minute, name: 'campaignManagement.logs.list.filter.timeRange.options.last10Minute' },
    { id: LogTimeRange.Last30Minute, name: 'campaignManagement.logs.list.filter.timeRange.options.last30Minute' },
    { id: LogTimeRange.CustomRange, name: 'campaignManagement.logs.list.filter.timeRange.options.customRange' },
];

export {
    CampaignStep,
    CampaignSortModel,
    CampaignStatus,
    CampaignRepeatType,
    CampaignRepeatDay,
    CampaignFileTypes,
    RuleFormInput,
    RuleExecutionType,
    RuleType,
    RuleCondition,
    RuleSwitchValue,
    RuleCustomerType,
    RulePlatform,
    RuleDeliveryMethod,
    RuleShippingCompany,
    RulePaymentMethod,
    RulePaymentCollector,
    RuleCreditCardType,
    RuleAndEarningModalNames,
    EarningFormInput,
    EarningApplicationScopeType,
    EarningProductDiscountScopeType,
    EarningCalculationDiscountType,
    EarningOptionalSetting,
    EarningValue,
    EarningBasePrice,
    EarningPriceSortingType,
    EarningDistributionType,
    CouponStatus,
    CouponGenerationType,
    CouponExecutionType,
    CouponCharacterSetType,
    WebsiteFolderType,
    MatrixCampaignType,
    CouponFormInput,
    LogTimeRange,
    CampaignSteps,
    CampaignStatuses,
    CampaignRepeatTypes,
    CampaignRepeatDays,
    RuleListCondition,
    RuleNumberCondition,
    RuleBooleanCondition,
    RuleCustomerTypeValues,
    RulePlatformValues,
    RuleDeliveryMethodValues,
    RuleShippingCompanyValues,
    RulePaymentMethodValues,
    RulePaymentCollectorValues,
    RuleCreditCardTypeValues,
    EarningApplicationScopeTypeValues,
    MatrixCampaignTypes,
    CouponGenerationTypes,
    CouponCharacterSetTypes,
    LogTimeRanges,
};
